/**
 * Exit from an app in three ways.
 *
 * @module app.exit
 */

'use strict';

var app = require('mag-app');


/** Go back to Launcher from an app. */
exports.goBack = function () {
    core.call('stop');
};


/**
 * Exit from an app by pressing "Exit/Home" button.
 * Potentially save app state.
 */
exports.goHome = function () { /* action */ };


/**
 * Exit from an app.
 * Destroy all application instances.
 * If callback function provided, and callback returns boolean 'true', application will stay alive.
 *
 * @param {PanelSet} panelSet - panel set to return focus
 * @param {Function} [callback] - provide callback if u want to handle exit result, or cancel it
 */
exports.goExit = function ( panelSet, callback ) {
    var ModalMessage  = require('mag-component-modal'),
        LayoutList    = require('mag-component-layout-list'),
        keys          = require('stb-keys'),
        previousFocus = app.activePage.activeComponent,
        exitModal;

    app.activePage.add(exitModal = new ModalMessage({
        title: gettext('Exit'),
        events: {
            show: function () {
                panelSet.blur();
                this.children[0].focus();
            },
            hide: function () {
                previousFocus.focus();
            }
        },
        children: [
            new LayoutList({
                className: 'padded',
                size: 2,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                value: gettext('Yes')
                            }
                        ],
                        click: function () {
                            if ( typeof callback === 'function' ) {
                                if ( callback(true) ) {
                                    exitModal.hide();
                                    exitModal.remove();

                                    return;
                                }
                            }

                            exitModal.hide();
                            exitModal.remove();
                            core.call('exit');
                        }
                    },
                    {
                        items: [
                            {
                                value: gettext('No')
                            }
                        ],
                        click: function () {
                            if ( typeof callback === 'function' ) {
                                callback(false);
                            }
                            exitModal.hide();
                            exitModal.remove();
                            panelSet.focus();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.back ) {
                            event.stop = true;
                            if ( typeof callback === 'function' ) {
                                callback(false);
                            }
                            exitModal.hide();
                            exitModal.remove();
                            panelSet.focus();
                        }
                    }
                }
            })
        ]
    }));

    exitModal.show();
    exitModal.focus();
};
